import classifiesAsWhiff from "../../classificators/whiffClassifier.js";
import BinToQualifiersCountConverter from "./BinToQualifiersCountConverter.js";

class BinToWhiffsConverter extends BinToQualifiersCountConverter {
    constructor(whiffClassifier, pitchResultPath, customResultsProcessor, silent, defaultValue) {
        if (typeof(whiffClassifier) === 'undefined') {
            whiffClassifier = classifiesAsWhiff;
        }

        super(whiffClassifier, pitchResultPath, customResultsProcessor, silent, defaultValue);
    }
}

export default BinToWhiffsConverter;